@use "@fukuri-admins/ui/layout" as *;

.root {
  box-sizing: border-box;

  @media (max-width: 1140px) {
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }

  @media (max-width: 700px) {
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }

  @media (max-width: 540px) {
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }
}

.container {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;

  @media (max-width: 1140px) {
    padding: 96px 48px;
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }

  @media (max-width: 700px) {
    padding: 48px;
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }

  @media (max-width: 540px) {
    padding: 24px;
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }
}

.title {
  text-align: left;
  font-weight: 600er;
  margin-bottom: 40px;
}

.mainContainer {
  width: 100%;
}

.form {
  max-width: 400px;
  text-align: left;
  color: $Text;
  font-size: 16px;

  .formTitle {
    color: $TextInput;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: 600;
    text-align: left;

    @media (max-width: 440px) {
      font-size: 12px;
    }
  }
}

.formBtn {
  margin-top: 32px;

  @media (max-width: 540px) {
    margin-top: 24px;
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }
}

.backLink {
  display: inline-block;
  padding: 12px 40px;
  margin-top: 32px;
  background-color: $ButtonGray;
  color: $White;
  transition: background-color 0.2s ease-out;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    background-color: $ButtonGrayHover;
  }
}

.menuItemRoot {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid $Border;
  padding: 16px;
  margin-bottom: 16px;

  .menuItem {
    .menuItemTitle {
      color: $TextLabel;
      font-size: 14px;
      margin-bottom: 4px;
      font-weight: 600;
    }
  }
}

.section {
  margin-top: 16px;
}

.sectionTitle {
  font-size: 21px;
  font-weight: 600;
  margin-bottom: 32px;
  color: #333;
}

.pageTitle {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 24px;
  color: $Text;
  position: relative;
  padding-bottom: 12px;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: $Border;
  }
}

.formWrapper {
  .formRow {
    margin-bottom: 12px;

    .formLabel {
      font-weight: 600;
      font-size: 16px;
      color: #666;
      margin-bottom: 8px;
    }

    .formValue {
      font-size: 16px;
      color: #333;
    }
  }
}
.gap {
  margin: 2rem 0;
}
.menuGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
}

.menuCard {
  border: 1px solid $Border;
  border-radius: 8px;
  padding: 16px;
  background-color: $White;
}

.menuTitle {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #666;
}

.menuContent {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.menuRow {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .menuLabel {
    font-weight: 600;
    font-size: 14px;
  }

  .menuValue {
    color: $Text;
    font-size: 14px;
  }
}
.imageContainer {
  width: 100%;
  max-width: 400px;
  margin: 8px 0;
  border-radius: 8px;
  overflow: hidden;
  background-color: $ButtonGray;
}

.mainImage {
  width: 100%;
  height: auto;
  object-fit: contain;
  background-color: $LightGray;
  display: block;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  &.errorImage {
    opacity: 0.5;
  }
}

.imagesGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  margin: 8px 0;
}

.imageContainer {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background-color: $ButtonGray;
}

.contentImage {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
  background-color: $LightGray;
  &:hover {
    transform: scale(1.05);
  }

  &.errorImage {
    opacity: 0.5;
  }
}

.noImage {
  width: 100%;
  height: 200px;
  background-color: $ButtonGray;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $White;
  border-radius: 8px;
  font-size: 14px;
}
